<template>
    <ForgotForm />
</template>

<script>
import ForgotForm from "@/components/ForgotForm.vue";

export default {
    name: 'ForgotView',
    components: {
        ForgotForm
    }
}
</script>